import { useState, useEffect, useCallback } from 'react'
import { Alert, Box, Button, Collapse } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'context/AuthContext'
import { getDaysLeft } from 'utils'
import IndentityCard from 'Components/IdentityCard/IndentityCard'
import ProfileActivityCard from 'Components/ProfileActivityCard/ProfileActivityCard'
import ProfileHealthCard from 'Components/ProfileHealthCard/ProfileHealthCard'
import TopLinksCard from 'Components/TopLinksCard/TopLinksCard'
import ProfileTipsCard from 'Components/ProfileTipsCard/ProfileTipsCard'
import WhatsNewCard from 'Components/WhatsNewCard/WhatsNewCard'
import LinkertoProCard from 'Components/LinkertoProCard/LinkertoProCard'
import RestoreAccountModal from 'Components/RestoreAccountModal'
import './Main.css'

const Main = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [alertVisible, setAlertVisible] = useState(false)
  const [restoreOpen, setRestoreOpen] = useState(false)

  useEffect(() => {
    if (!user?.deletedAt) return
    const timer = setTimeout(() => setAlertVisible(true), 1200)
    return () => clearTimeout(timer)
  }, [user?.deletedAt])

  const handleCloseRestore = useCallback(() => setRestoreOpen(false), [])

  return (
    <Box sx={{ width: '100%' }}>
      {user?.deletedAt && (
        <Collapse in={alertVisible} unmountOnExit>
          <Alert
            severity="error"
            className="deletion-alert"
            onClose={() => setAlertVisible(false)}
            action={
              <Button
              variant="outlined"
              color="inherit"
              size="large"
              className="deletion-alert-btn"
              onClick={() => setRestoreOpen(true)}
            >
              {t('dashboard.main.deletion-alert.cancel-btn')}
            </Button>
            }
          >
            <span
              dangerouslySetInnerHTML={{
                __html: t('dashboard.main.deletion-alert.message', {
                  days: getDaysLeft(user.deletedAt),
                }),
              }}
            />
          </Alert>
        </Collapse>
      )}

      <Box className="main-cards-container">
        <IndentityCard />
        <ProfileHealthCard />
        <TopLinksCard />
        <ProfileActivityCard />
        <ProfileTipsCard />
        <WhatsNewCard />
        <LinkertoProCard />
      </Box>

      <RestoreAccountModal open={restoreOpen} onClose={handleCloseRestore} />
    </Box>
  )
}

export default Main
